<template>
  <ItemForm mode="edit" />
</template>

<script>
import ItemForm from "@/components/product/ItemForm.vue";

export default {
  name: "editproduct",
  components: { ItemForm },
};
</script>
